
import GoodsListPage from '@/components/GoodsListPage'
import pzBadge from '@/components/pzBadge'
import { mapGetters } from 'vuex'
import { orderStatusBySeller } from '@/enum/localEnum'
import { filterDirtyHTML } from '@/utils/filter-dirty-html'
import PZTabs from '@/components/PZTabs'
import PZCategory2 from '@/components/PZTabs/Category2.vue'
import OrderBoxSellGoods from './OrderBoxSellGoods.vue'
import OrderBoxTabTitle from './OrderBoxTabTitle.vue'
import { formatCount } from '@/utils'

export default {
	components: {
		GoodsListPage,
		pzBadge,
		PZTabs,
		PZCategory2,
		OrderBoxSellGoods,
		OrderBoxTabTitle
	},
	props: {
		tabTitle: {
			type: String
		},
		jumpUrl: {
			type: String
		},
		showNavRight: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			goodsCatalogueId: 6,
			keywords: null,
			sellNavIndex: null,
			sellNavList: [],
			showBack: false,
			lists: [],
			loading: true,
			pageInfo: {
				page: 1,
				pageSize: this.jumpUrl ? 5 : 10,
				total: 0
			},
			buyerList: [],
			centerPayDialogVisible: false, // 支付方式
			centerPayQRDialogVisible: false, // 关闭支付提示
			parInfo: {}, //创建订单回调信息
			numIndex: 8, //定义当前使用tabs长度
			newTabs: [], //用来显示tabs
			categoryList: [], //用来显示商品分类
			selectedCategory: null //用来显示当前选中的分类
		}
	},

	computed: {
		...mapGetters({
			goodsTypeCateList: 'game/goodsTypeCateList',
			myGoodsPage: 'myGoodsPage',
			userinfo: 'user/userinfo'
		})
	},
	watch: {
		$route: {
			handler: function (route) {
				this.sellNavIndex = (route.query && route.query.status) || null
			},
			immediate: true
		},
		keywords: {
			handler: function (v) {
				if (!v) {
					this.getSellerCenter(null)
				}
			}
		}
	},
	methods: {
		// 左箭头
		left() {
			if (this.numIndex > 8) {
				this.newTabs.unshift(this.sellNavList[this.numIndex - 9])
				this.newTabs.pop(this.newTabs[this.numIndex])
				this.numIndex--
			}
		},
		// 右箭头
		right() {
			if (this.numIndex < this.sellNavList.length - 1) {
				this.newTabs.shift(this.newTabs[this.numIndex - 9])
				this.newTabs.push(this.sellNavList[this.numIndex + 1])
				this.numIndex++
			}
		},

		searchBtn() {
			if (!this.keywords) return
			this.loading = true
			this.getSellerCenter([this.keywords])
		},
		getTime(item) {
			let label = null
			let value = ''
			switch (item.status) {
				case orderStatusBySeller.ONESELF_DOWN_STAND:
					label = '下架时间'
					value = item.oneselfDownStandTime
					break
				case orderStatusBySeller.FORCE_DOWN_STAND:
					label = '下架时间'
					value = item.forceDownStandTime
					break
				case orderStatusBySeller.VERIFY_FAIL:
					label = '审核时间'
					value = item.verifyTime
					break
				case orderStatusBySeller.BEAN_SOLD:
					label = '成交时间'
					value = item.transactionTime
					break
				case orderStatusBySeller.ON_STAND:
					label = '上架时间'
					value = item.onStandTime
					break
				// 待审核和交易中
				default:
					label = '创建时间'
					value = item.createTime
					break
			}
			return `${label}：${value}`
		},
		gotoDetails(item) {
			if (item.goodsCatalogueId === 6) {
				this.$router.push({
					path: '/account/sellerDetails',
					query: {
						orderStatus: item.statusName,
						status: item.status,
						goodsNo: item.goodsNo,
						gameId: item.gameId,
						goodsCatalogueId: item.goodsCatalogueId
					}
				})
			} else {
				this.$router.push({
					path: '/account/sellerOtherDetails',
					query: {
						status: item.status,
						goodsNo: item.goodsNo,
						gameId: item.gameId,
						goodsCatalogueId: item.goodsCatalogueId,
						goodsSubCatalogueId: item.goodsSubCatalogueId
					}
				})
			}
		},
		async activeSellNav(item) {
			this.pageInfo.page = 1
			this.sellNavIndex = item.key
			let _page = {
				page: 1,
				pageSize: this.pageInfo.pageSize,
			}
			this.$store.commit('SET_MY_GOODS_PAGE', _page)
			this.$router.push({
				path: '/account/sellerList',
				query: {
					status: item.key
				}
			})
			if (item.key == 'CANCEL') {
				this.getOrderList()
			} else {
				this.getSellerCenter()
			}
			this.sellNavList = await this.setMenuDot(this.sellNavList)
			console.log(this.sellNavList, '==============');
			
		},
		onCategoryChange(category) {
			this.selectedCategory = category.catalogueId
			this.pageInfo.page = 1
			let _page = {
				page: 1,
				pageSize: this.pageInfo.pageSize,
			}
			this.$store.commit('SET_MY_GOODS_PAGE', _page)
			if (this.sellNavIndex == 'CANCEL') {
				this.getOrderList()
			} else {
				this.getSellerCenter()
			}
		},
		// 下一页
		handleCurrentChange(page) {
			this.pageInfo.page = page
			let _page = {
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			this.$store.commit('SET_MY_GOODS_PAGE', _page)
			if (this.sellNavIndex == 'CANCEL') {
				this.getOrderList()
			} else {
				this.getSellerCenter()
			}
		},
		// 分页总数
		handleSizeChange(pageSize) {
			this.pageInfo.page = 1
			this.pageInfo.pageSize = pageSize
			let _page = {
				page: 1,
				pageSize: this.pageInfo.pageSize
			}
			this.$store.commit('SET_MY_GOODS_PAGE', _page)
			if (this.sellNavIndex == 'CANCEL') {
				this.getOrderList()
			} else {
				this.getSellerCenter()
			}
		},
		/**
		 * 获取卖家商品列表
		 */
		getSellerCenter(keywords) {
			if (this.keywords) {
				keywords = [this.keywords]
			}
			let p = {
				action: {
					keywords: keywords,
					goodsStatus: this.sellNavIndex,
					goodsCatalogueId: this.selectedCategory
				},
				page: this.myGoodsPage.page ? this.myGoodsPage.page : this.pageInfo.page,
				pageSize: this.myGoodsPage.pageSize ? this.myGoodsPage.pageSize : this.pageInfo.pageSize
			}

			this.$api.getGeneralGoodsList(p).then(res => {
				if (!res.success) {
					this.loading = false
					this.$message.error(res.info)
					return
				}
				let data = res.data
				this.lists = data.records
				this.lists.map(item => {
					if (item.goodsImg) {
						return (item.goodsImg = item.goodsImg && item.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg'))
					}
				})
                const goodsNoList = this.lists.map(item => {return {goodsNo:item.goodsNo,onStandTime:item.onStandTime}})
                const params = { action: [...goodsNoList] }
                this.$api.getGoodsWantAndSeenNum(params).then(d=>{
                    if(d.success && d?.data?.length){
                        const map = new Map(d.data.map(d => [d.goodsNo, d]))
                        this.lists.forEach(item => {
                            const numItem = map.get(item.goodsNo)
                            if(numItem){
                                this.$set(item, 'seenNum', numItem.seenNum || 0)
                                this.$set(item, 'seenText', formatCount(numItem.seenNum || 0))
                            }
                        })
                    }
                })
				this.pageInfo.page = data.page
				this.pageInfo.total = Number(data.total)
				this.loading = false
				console.log(this.lists)
			})
		},
		/**
		 * 设置小红点
		 */
		async setMenuDot(menu) {
			const [order, goods] = await Promise.all([this.$api.getSellerOrderTodo(), this.$api.getSellerGoodsTodo()])
			if (!goods.data) return
			if (!order.data) return
			const { orderTodoTotal, failAuditTotal, publishTotal, toAuditTotal } = {
				...goods.data,
				...order.data
			}
			const subMenuDotTotal = {
				TRADING: orderTodoTotal, // 交易中
				WAIT_VERIFY: toAuditTotal, // 待审核
				VERIFY_FAIL: failAuditTotal, // 审核失败
				WAIT_PUBLISH: publishTotal // 待发布
			}
			return menu.map(item => {
				const updatedItem = { ...item }
				if (['TRADING', 'WAIT_VERIFY', 'VERIFY_FAIL', 'WAIT_PUBLISH'].includes(updatedItem.key)) {
					updatedItem.dot = subMenuDotTotal[updatedItem.key]
				}
				return updatedItem
			})
		},
		// 获取卖家tab页数据
		async getListGoodsStatus() {
			let p = {
				action: {}
			}
			const res = await this.$api.listGoodsStatus(p)
			if (!res.success) {
				this.$message.error(res.info)
				return
			}
			const filteredData = (res.data || []).filter(item => !['TRADING', 'BEAN_SOLD','AUCTION'].includes(item.key))
			this.sellNavList = await this.setMenuDot(filteredData)
			// this.sellNavList.push({
			// 	key: 'CANCEL',
			// 	value: '已取消'
			// })
			// 设置tabs数量大于10时重新组装数据
			if (this.sellNavList.length > 9 && this.showNavRight) this.newTabs = this.sellNavList.slice(0, 9)
			else this.newTabs = this.sellNavList
		},
		// 获取卖家订单列表
		getOrderList() {
			let p = {	
				action: {
					orderStatus: this.sellNavIndex
				},
				page: this.pageInfo.page,
				pageSize: this.pageInfo.pageSize
			}
			this.$api.userCenterSellerOrder(p).then(res => {
				if (!res.success) {
					this.$message.error(res.info)
					return
				}
				let data = res.data
				this.buyerList = data.records
				this.pageInfo.page = data.page
				this.pageInfo.total = Number(data.total)
				this.loading = false
			})
		},
		// 获取卖家商品列表
		async getCategoryList() {
			const res = await this.$api.getGeneralGoodsCateList()
			if (!res.success) return this.$message.error(res.info)
			this.categoryList = res.data
		},
		// 支付违约金
		getPayOrder(item) {
			let data = {
				orderNo: item.orderNo
			}
			this.$api.orderDetails(data).then(res => {
				if (res.success) {
					this.parInfo = {
						...res.data,
						payName: '违约金',
						businessScene: 'SELLER_LIQUIDATED_DAMAGES'
					}
					this.centerPayDialogVisible = true
					this.$nextTick(() => {
						this.$refs['qrPay'].getQrCode(this.parInfo)
					})
				} else {
					this.$message.error(res.info)
				}
			})
		},
		// 关闭支付方式弹窗
		closePayDialogVisible(done) {
			this.centerPayQRDialogVisible = true
			if (!this.centerPayQRDialogVisible) {
				done()
			}
		},
		// 退出支付方式
		closePayDialogOkVisible() {
			this.centerPayQRDialogVisible = false
			this.centerPayDialogVisible = false
			this.$refs['qrPay'].closeDialogVisible()
		},
		// 支付成功回调
		paySuccess(payStatus, msg = '支付失败') {
			if (payStatus === 'PAY_SUCCESS') {
				this.$message.success('支付成功！')
				this.$refs['qrPay'].closeDialogVisible()
				this.getOrderList()
			} else {
				this.centerPayDialogVisible = payStatus
				this.$refs['qrPay'].closeDialogVisible()
			}
		},
		filterVHTML(htmlStr) {
			return filterDirtyHTML(htmlStr)
		}
	},
	mounted() {
		this.getListGoodsStatus()
		this.getCategoryList()
		if (this.sellNavIndex == 'CANCEL') {
			this.getOrderList()
		} else {
			this.getSellerCenter()
		}
	},
	created() {
		if (process.client) this.$store.dispatch('game/GoodsTypeCateList')
	}
}
